import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28fdbe5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step__two" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите серию паспорта", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Пример: 2212", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Введите номер паспорта", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Пример: 999654", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Дата выдачи", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Пример: 20.02.2002", -1))
const _hoisted_9 = ["max"]
const _hoisted_10 = { class: "right" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Кем выдан паспорт", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Пример: Отделом УФМС России по гор. Москва по району Митино", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Код подразделения", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Пример: 770-093", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Где зарегистрирован", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Пример: г. Москва, ул. Ленина, д. 74, кв. 105", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputMask = _resolveComponent("InputMask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "0000",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document.signatory_passport_seria) = $event)),
          maxlength: "4",
          onkeypress: "return (event.charCode >= 48 && event.charCode <= 57)"
        }, null, 512), [
          [_vModelText, _ctx.document.signatory_passport_seria]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "text",
          placeholder: "000000",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.signatory_passport_number) = $event)),
          maxlength: "6",
          onkeypress: "return event.charCode >= 48 && event.charCode <= 57"
        }, null, 512), [
          [_vModelText, _ctx.document.signatory_passport_number]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_7,
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "date",
          placeholder: "__.__.____",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.signatory_when_issued) = $event)),
          maxlength: "10",
          onkeypress: "return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46",
          max: _ctx.currentDay
        }, null, 8, _hoisted_9), [
          [_vModelText, _ctx.document.signatory_when_issued]
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save_complete && _ctx.save_complete(...args))),
        class: "save_btn"
      }, "Готово")
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        _hoisted_11,
        _hoisted_12,
        _withDirectives(_createElementVNode("textarea", {
          class: "input",
          style: {"padding-top":"17px","resize":"none","overflow":"hidden"},
          type: "text",
          placeholder: "Введите учреждение",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.signatory_passport_issued) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.signatory_passport_issued]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_13,
        _hoisted_14,
        _createVNode(_component_InputMask, {
          modelValue: _ctx.document.signatory_division_code,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.document.signatory_division_code) = $event)),
          mask: "999-999",
          placeholder: "999-999"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_15,
        _hoisted_16,
        _withDirectives(_createElementVNode("textarea", {
          class: "input",
          style: {"padding-top":"16px","resize":"none","overflow":"hidden"},
          type: "text",
          placeholder: "Введите адрес регистрации",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.document.signatory_passport_registration) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.signatory_passport_registration]
        ])
      ])
    ])
  ]))
}